import { StudyDto } from './../_models/studyBrowser.models';
import { APP_CONFIGS } from './../_constants/config.constants';
import axios, { AxiosResponse } from 'axios';
import { AddStudyOperationCommentPayloadDto, DownloadFactoryStudySummaryReportParams, DownloadSbuStudySummaryReportParams, StudyBrowserListFiltersParamsDto } from '../_models';

const getStudyBrowserList = (filters: StudyBrowserListFiltersParamsDto): Promise<AxiosResponse<StudyDto[]>> => {
    return axios.get('/api/v1/studies', {params: filters});
}

const getStudyBrowserDetail = (studyBrowserId: number) => {
    return axios.get(`/api/v1/studies/${studyBrowserId}`);
}

const addStudyOperationComment = (data: AddStudyOperationCommentPayloadDto): Promise<AxiosResponse<any>> => {
    return axios.put(`/api/v1/studies/studyOperationTimes`, data);
}

const getStudyDependentDetail = (parentStudyId: number) => {
    return axios.get(`/api/v1/studies/dependedstudies`, {params: {parentStudyId}});
}

const downloadStudyReport = (studyId: number) => {
    window.open(`${APP_CONFIGS.API_BASE}/api/v1/studies/download?studyId=${studyId}&Subscription-Key=${APP_CONFIGS.APIM_SUBSCRIPTION_KEY}`)
}

const downloadSbuStudySummaryReport= (params: DownloadSbuStudySummaryReportParams) => {
    window.open(`${APP_CONFIGS.API_BASE}/api/v1/studies/downloadSbuStudy?sbuId=${params.sbuId}&startDate=${params.startDate}&endDate=${params.endDate}&Subscription-Key=${APP_CONFIGS.APIM_SUBSCRIPTION_KEY}`)
}

const downloadFactoryStudySummaryReport= (params: DownloadFactoryStudySummaryReportParams) => {
    window.open(`${APP_CONFIGS.API_BASE}/api/v1/studies/downloadFactoryWiseCount?startDate=${params.startDate}&endDate=${params.endDate}&Subscription-Key=${APP_CONFIGS.APIM_SUBSCRIPTION_KEY}`)
}

export const studyBrowserService = {
    getStudyBrowserList,
    getStudyBrowserDetail,
    downloadStudyReport,
    getStudyDependentDetail,
    downloadSbuStudySummaryReport,
    downloadFactoryStudySummaryReport,
    addStudyOperationComment
}
